"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Merge = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const lodash_1 = require("lodash");
const errors_1 = require("@ledgerhq/errors");
const types_1 = require("./types");
const utils = __importStar(require("../utils"));
const logs_1 = require("@ledgerhq/logs");
class Merge extends types_1.PickingStrategy {
    selectUnspentUtxosToUse(xpub, outputs, feePerByte) {
        return __awaiter(this, void 0, void 0, function* () {
            // get the utxos to use as input
            // from all addresses of the account
            const addresses = yield xpub.getXpubAddresses();
            (0, logs_1.log)("picking strategy", "Merge");
            let unspentUtxos = (0, lodash_1.flatten)(yield Promise.all(addresses.map(address => xpub.storage.getAddressUnspentUtxos(address)))).filter(o => !this.excludedUTXOs.filter(x => x.hash === o.output_hash && x.outputIndex === o.output_index).length);
            const outputScripts = outputs.map(o => o.script);
            const emptyTxSize = utils.maxTxSizeCeil(0, [], false, this.crypto, this.derivationMode);
            const sizePerInput = utils.maxTxSize(1, [], false, this.crypto, this.derivationMode) - emptyTxSize;
            const sizePerOutput = (outputScripts[0]
                ? utils.maxTxSize(0, [outputScripts[0]], false, this.crypto, this.derivationMode)
                : utils.maxTxSize(0, [], true, this.crypto, this.derivationMode)) - emptyTxSize;
            unspentUtxos = (0, lodash_1.sortBy)(unspentUtxos, utxo => parseInt(utxo.value, 10));
            // https://metamug.com/article/security/bitcoin-transaction-fee-satoshi-per-byte.html
            const txSizeNoInput = utils.maxTxSize(0, outputScripts, false, this.crypto, this.derivationMode);
            let fee = txSizeNoInput * feePerByte;
            let total = new bignumber_js_1.default(0);
            const unspentUtxoSelected = [];
            let i = 0;
            const amount = outputs.reduce((sum, output) => sum.plus(output.value), new bignumber_js_1.default(0));
            while (total.lt(amount.plus(fee))) {
                if (!unspentUtxos[i]) {
                    throw new errors_1.NotEnoughBalance();
                }
                total = total.plus(unspentUtxos[i].value);
                unspentUtxoSelected.push(unspentUtxos[i]);
                fee += sizePerInput * feePerByte;
                i += 1;
            }
            if (total.minus(amount.plus(fee)).lt(sizePerOutput * feePerByte)) {
                // not enough fund to make a change output
                return {
                    totalValue: total,
                    unspentUtxos: unspentUtxoSelected,
                    fee: Math.ceil(fee),
                    needChangeoutput: false,
                };
            }
            fee += sizePerOutput * feePerByte; // fee to make a change output
            return {
                totalValue: total,
                unspentUtxos: unspentUtxoSelected,
                fee: Math.ceil(fee),
                needChangeoutput: true,
            };
        });
    }
}
exports.Merge = Merge;
//# sourceMappingURL=Merge.js.map